import { Table, TableColumn, Typography } from '@scale/scaleui';
import { ISensorFusionSubstageDefinitionLookupDto } from '@scale/sensor-fusion-shared';
import { SubstageInstanceStatus, SubstageInstanceStatusValues } from '@scale/shared-types';

type SubstageDefinitionBreakdownPanelProps = {
  substageDefinition: ISensorFusionSubstageDefinitionLookupDto;
};

const TABLE_COLUMNS: TableColumn[] = [
  { header: 'Not Started', id: SubstageInstanceStatus.NotStarted },
  { header: 'In Progress', id: SubstageInstanceStatus.InProgress },
  { header: 'Completed', id: SubstageInstanceStatus.Completed },
  { header: 'Total', id: 'total' },
];

const SubstageDefinitionBreakdownPanel = ({
  substageDefinition,
}: SubstageDefinitionBreakdownPanelProps) => {
  const { statusCounts } = substageDefinition;

  const tableData = [
    {
      ...Object.keys(SubstageInstanceStatus).reduce((acc, key) => {
        const statusKey = SubstageInstanceStatus[key as keyof typeof SubstageInstanceStatus];

        acc[statusKey] =
          (statusCounts.claimed[statusKey] || 0) + (statusCounts.unclaimed[statusKey] || 0);
        return acc;
      }, {} as Record<SubstageInstanceStatusValues, number>),
      total: Object.values(SubstageInstanceStatus).reduce(
        (total, status) => total + statusCounts.unclaimed[status] + statusCounts.claimed[status],
        0,
      ),
    },
  ];

  return (
    <div className="border border-solid border-neutral-200 px-4 py-4 flex flex-col gap-2">
      <Typography.H3>Breakdown</Typography.H3>
      <Table columns={TABLE_COLUMNS} data={tableData} manualPagination />
    </div>
  );
};

export default SubstageDefinitionBreakdownPanel;
